/**
 * ProductImg — procedural gradient product placeholder.
 * Atom purity: imports only react + tokens.
 */
import { CSSProperties } from 'react';

export interface ProductImgProps {
  h?: number;
  w?: number | string;
  r?: number;
  hue?: number;
  label?: string;
  style?: CSSProperties;
}

export function ProductImg({
  h = 120,
  w = '100%',
  r = 12,
  hue = 18,
  label,
  style,
}: ProductImgProps) {
  // Prototype.jsx ProductImg (lines 214-227): soft, desaturated warm gradient — NOT a loud swatch.
  const hue2 = (hue + 30) % 360;
  const bg = `radial-gradient(circle at 30% 25%, hsl(${hue},30%,92%), hsl(${hue2},25%,78%))`;

  return (
    <div
      style={{
        width: w,
        height: h,
        borderRadius: r,
        background: bg,
        position: 'relative',
        overflow: 'hidden',
        flexShrink: 0,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.04)',
        ...style,
      }}
    >
      {/* Soft inner glow for depth */}
      <div
        style={{
          position: 'absolute',
          inset: '15%',
          borderRadius: '50%',
          background: `radial-gradient(circle, hsla(${hue},40%,55%,0.30), transparent 70%)`,
        }}
      />
      {label && (
        <div
          style={{
            position: 'absolute',
            bottom: 6,
            left: 8,
            fontSize: 9,
            color: 'rgba(255,255,255,0.80)',
            fontFamily: 'ui-monospace, monospace',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            textShadow: '0 1px 2px rgba(0,0,0,0.25)',
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}
